import { type Namespace } from 'i18next';

export const dataI18n = ['common', 'data'] satisfies Namespace;
